import React, { useEffect, useState } from "react";
import { Sun, Moon, Bot, FileDown, LogOut, User } from "lucide-react";
import Logo from "./Logo";
import AlertsBell from "./AlertsBell";
import { useAuth } from "../lib/AuthContext";
import { useNavigate } from "react-router-dom";

export const Header = ({ tickerItems = [], onOpenAI, onExportPDF, exporting }) => {
  const [now, setNow] = useState(new Date());
  const [tickerIdx, setTickerIdx] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (!tickerItems.length) return;
    const t = setInterval(() => setTickerIdx((i) => (i + 1) % tickerItems.length), 6000);
    return () => clearInterval(t);
  }, [tickerItems.length]);

  // Show 2 rotating ticker items at a time (smaller, less crowded header)
  const visibleItems = (() => {
    if (!tickerItems.length) return [];
    const out = [];
    for (let i = 0; i < 2; i++) out.push(tickerItems[(tickerIdx + i) % tickerItems.length]);
    return out;
  })();

  const doLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="nms-header" data-testid="app-header">
      <div className="nms-brand">
        <Logo size={44} />
        <div className="nms-brand-text">
          <h1 className="nms-brand-title" data-testid="app-title">
            National &amp; Monitoring System
          </h1>
          <div className="nms-brand-sub">REPUBLIK INDONESIA · SISTEM PEMANTAUAN</div>
        </div>
      </div>

      <div className="nms-ticker-strip" data-testid="header-ticker">
        {visibleItems.map((it, i) => (
          <div key={`${tickerIdx}-${i}`} className="nms-ticker-pill">
            <span className="dot" />
            <span className="t-lbl">{it.label}</span>
            <span className="t-sep">·</span>
            <span className="t-val">{it.value}</span>
            {it.change ? <span className={`t-chg ${it.dir || ""}`}>{it.change}</span> : null}
          </div>
        ))}
      </div>

      <div className="nms-header-right">
        <button
          type="button"
          className="hdr-action ai-action"
          onClick={onOpenAI}
          title="Tanya AI Assistant"
          data-testid="header-ai-btn"
        >
          <Bot size={14} />
          <span className="hdr-action-lbl">AI</span>
        </button>

        <button
          type="button"
          className="hdr-action"
          onClick={onExportPDF}
          disabled={exporting}
          title="Export laporan PDF"
          data-testid="header-export-btn"
        >
          <FileDown size={14} />
          <span className="hdr-action-lbl">{exporting ? "..." : "PDF"}</span>
        </button>

        <AlertsBell />

        <div className="nms-clock-chip" title={now.toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}>
          {now.getHours() >= 6 && now.getHours() < 18 ? (
            <Sun size={13} className="time-ico day" />
          ) : (
            <Moon size={13} className="time-ico night" />
          )}
          <span data-testid="header-clock" className="clock-full">
            {now.toLocaleTimeString("id-ID", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false,
            })}
          </span>
          <span data-testid="header-clock-short" className="clock-short">
            {now.toLocaleTimeString("id-ID", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })}
          </span>
        </div>

        <div className="hdr-user-wrap">
          <button
            type="button"
            className="hdr-user-btn"
            onClick={() => setMenuOpen((v) => !v)}
            data-testid="header-user-btn"
            title={user?.name || user?.username}
          >
            <User size={14} />
            <span className="hu-name">{user?.username || "user"}</span>
          </button>
          {menuOpen && (
            <div className="hdr-user-menu" data-testid="header-user-menu">
              <div className="hum-head">
                <strong>{user?.name || user?.username}</strong>
                <span>{user?.role}</span>
              </div>
              <button type="button" onClick={doLogout} data-testid="header-logout">
                <LogOut size={13} /> KELUAR
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
